import { useQuery } from '@tanstack/react-query';

import { contactsAPI, contactsEndpoints } from '@/api/contacts';

export const useContactDebts = (contactId?: string) => {
  const queryKey = [contactsEndpoints.debts(contactId ?? '')];

  const { data, status, error } = useQuery({
    queryKey,
    queryFn: () => contactsAPI.listDebts(contactId!),
    enabled: !!contactId,
  });

  const debts = data?.rows ?? [];
  const total = data?.total ?? debts.length;

  return { debts, total, status, error };
};
